import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold } from '../../../helpers/getEmailStyles';

class BookingExpiredGuest extends Component {
	static propTypes = {
		content: PropTypes.shape({
			listTitle: PropTypes.string.isRequired,
			guestName: PropTypes.string.isRequired,
			checkIn: PropTypes.string.isRequired
		}).isRequired
	};

	render() {
		const { content: { guestName, listTitle, checkIn, logo, siteName, checkOut } } = this.props;
		let checkInDate, checkOutDate
		checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '';
		checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Hi {guestName},
					</div>
					<EmptySpace height={20} />
					<div>
						Your reservation request for {listTitle} from {checkInDate} to {checkOutDate} has expired. Unfortunately, the host did not respond within the allotted time, so the request was automatically expired.
					</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}
}

export default BookingExpiredGuest;
